export const BID_SCOPES = Object.freeze([
  'Demo',
  'Grading',
  'Drainage',
  'Hardscape',
  'Softscape',
  'Irrigation',
  'Herbicide',
  'Water Feature',
  'Lighting',
  'Cleanup'
])
